const SafetyIconHookSafety = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M16.6299 18.7855C18.1531 20.9323 21.3583 20.5554 22.9286 18.7855L26.0521 15.6446C27.8172 13.7161 27.88 11.2253 26.0521 9.36276C24.2682 7.54575 21.5546 7.54575 19.7706 9.36276L16.6299 12.5037"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7697 17.3251C18.2464 15.1783 15.0586 15.4453 13.4882 17.2152L10.3475 20.3168C8.58238 22.2453 8.51957 24.7753 10.3475 26.6379C12.1314 28.4549 14.845 28.4549 16.629 26.6379L19.7697 23.497"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SafetyIconHookSafety
